import { createContext } from 'react';

export type ServiceName =
    'central' | 'blockmodel' | 'file' | 'geoscienceobject' | 'evo' | 'evo-next' | 'none';
export interface LoginHandlerContextState {
    imageList: string;
    includeClientSecret: boolean;
    forceOauthPrefix: boolean;
    service: ServiceName;
}

// CSSRecord value for backgroundImage
export const DEFAULT_BACKGROUND_IMAGES = `url(${'images/landing-page-background-detailed.jpg'}), url(${'images/landing-page-background.jpg'})`;
export const LoginContext = createContext<LoginHandlerContextState>({
    forceOauthPrefix: false,
    includeClientSecret: false,
    imageList: DEFAULT_BACKGROUND_IMAGES,
    service: 'evo',
});
